import React, { useMemo } from 'react'
import BodyText from 'LuxKit/Typography/BodyText'
import { FormattedMessage } from 'react-intl'

interface Props {
  offer: App.CarHireOffer
}

const boldChunks = (chunks: React.ReactNode) => <BodyText variant="small" as="span" weight="bold">{chunks}</BodyText>

function CarHireOfferTileLocation(props: Props) {
  const { offer } = props

  const hasDifferentLocations = useMemo(() => offer.pickUp.id !== offer.dropOff.id, [offer])

  return (
    <BodyText variant="small" colour="neutral-two">
      {hasDifferentLocations &&
        <FormattedMessage
          id="W6UapJNww3"
          defaultMessage="Pick up <bold>{pickUpName}</bold>, Drop off <bold>{dropOffName}</bold>"
          description="Car hire pick up and drop off locations when they are different"
          values={{
            pickUpName: offer.pickUp.name,
            dropOffName: offer.dropOff.name,
            bold: boldChunks,
          }}
        />}
      {!hasDifferentLocations &&
        <FormattedMessage
          id="qJxyoYElDx"
          defaultMessage="Pick up and drop off at <bold>{locationName}</bold>"
          description="Car hire pick up and drop off at the same location"
          values={{
            locationName: offer.pickUp.name,
            bold: boldChunks,
          }}
        />}
    </BodyText>
  )
}

export default CarHireOfferTileLocation
